import {Reducer} from 'redux'
import {CommentsActionTypes} from "@actions/comment";
import {CommentState} from "@models/comment";

// Type-safe initialState!
export const initialState: CommentState = {
    data: [],
    errors: undefined,
    loading: false,
    count: 0
};

const reducer: Reducer<CommentState> = (state = initialState, action) => {
    switch (action.type) {
        case CommentsActionTypes.FETCH_REQUEST: {
            return {
                ...state,
                loading: true
            }
        }

        case CommentsActionTypes.FETCH_SUCCESS: {
            const {data, meta} = action.payload;
            return {
                ...state,
                loading: false,
                data,
                count: meta.total_count,
                is_fetched: true
            }
        }

        case CommentsActionTypes.FETCH_ERROR: {
            return {...state, loading: false, errors: action.payload.error}
        }

        case CommentsActionTypes.UPDATE_SUCCESS: {
            const comment = action.payload;
            return {
                ...state,
                data: state.data.map(item => (item.id == comment.id) ? {
                    ...item,
                    ...comment
                } : item),
            }
        }

        default: {
            return state
        }
    }
};

export {reducer as commentsReducer}
